import React, { Suspense, useEffect } from "react";
import ReactDOM from "react-dom";
// react-router components
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";

// Material Dashboard 2 React example components
import Configurator from "examples/Configurator";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Dashboard 2 React themes
import theme from "assets/theme";

// Material Dashboard 2 React Dark Mode themes
import themeDark from "assets/theme-dark";

// Material Dashboard 2 React routes
import { authRoutes } from "routes";

// Material Dashboard 2 React contexts
import { useMaterialUIController } from "context";

// Images
import { useDispatch, useSelector } from "react-redux";
import { loginSelector, logoutHandler, resetTimer } from "store/login-slice";
import useLoading from "hooks/use-loading";
import BackDrop from "components/Loader/BackDrop";
import BoxLoader from "components/Loader/BoxLoader";

import ConfirmAlert from "components/ConfirmAlert";

const Tutor = React.lazy(() => import("./tutor/App"));
const SubTutor = React.lazy(() => import("./subtutor/App"));
const Student = React.lazy(() => import("./student/App"));
const Staff = React.lazy(() => import("./staff/App"));
// const LayoutDefault = React.lazy(() => import("homepage/layouts/LayoutDefault"));
// const ExpiredPlanMessage = React.lazy(() => import("components/ExpiredPlanMessage"));

export default function App() {
  const rdxDispatch = useDispatch();
  const navigate = useNavigate();
  // const location = useLocation();

  // it will check if user already logged in but open website again then it will logout user if timer is expired
  useEffect(() => {
    // console.log('first login time check');
    const now = new Date().getTime();
    let expirationTime = localStorage.getItem("expirationTime");
    expirationTime = new Date(expirationTime).getTime();
    if (now > expirationTime || expirationTime === undefined || expirationTime == null) {
      rdxDispatch(logoutHandler());
    }
  }, []);

  // not added dependency because it will check every activity and reset logout timer
  useEffect(() => {
    // console.log("resetTimer");
    rdxDispatch(resetTimer());
  }); // eslint-disable-line

  const { showLoader } = useLoading();

  const { isLoggedIn, isPlanExpired, userRole } = useSelector(loginSelector);
  // console.log(isLoggedIn, isPlanExpired, userRole, "states");

  useEffect(() => {
    // console.log(isPlanExpired);
    if (isPlanExpired === "true" && userRole === "tutor") {
      navigate("/select-plan");
    }
  }, [isPlanExpired]);

  // const isHomePage = location.pathname === "/" || location.pathname === "";
  // let HomePage = () => <></>;
  // if (isHomePage) {
  //   HomePage = React.lazy(() => import("homepage/HomePage"));
  // } else {
  //   HomePage = () => <></>;
  // }

  const [controller] = useMaterialUIController();
  const { direction, layout, darkMode } = controller;
  const { pathname } = useLocation();

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  const RouteConfigs = (
    <Routes>
      {/* <Route path="/" exact element={<HomePage />} layout={LayoutDefault} /> */}
      {isLoggedIn && userRole === "tutor" && <Route path="*" element={<Tutor />} />}
      {isLoggedIn && userRole === "subtutor" && <Route path="*" element={<SubTutor />} />}
      {isLoggedIn && userRole === "student" && <Route path="*" element={<Student />} />}
      {isLoggedIn && userRole === "staff" && <Route path="*" element={<Staff />} />}
      {!isLoggedIn && (
        <>
          {getRoutes(authRoutes)}
          <Route path="*" element={<Navigate to="authentication/sign-in" />} />
        </>
      )}
    </Routes>
  );

  const Loader = (
    <>
      {ReactDOM.createPortal(<BackDrop />, document.getElementById("backdrop"))}
      {ReactDOM.createPortal(<BoxLoader />, document.getElementById("loader"))}
    </>
  );

  return (
    <Suspense fallback={Loader}>
      <>
        {showLoader && Loader}
        <ThemeProvider theme={darkMode ? themeDark : theme}>
          <ConfirmAlert />
          <CssBaseline />
          {layout === "dashboard" && <Configurator />}
          {layout === "vr" && <Configurator />}
          {RouteConfigs}
        </ThemeProvider>
      </>
    </Suspense>
  );
  // return (
  //   <Suspense fallback={Loader}>
  //     {isHomePage && RouteConfigs}
  //     {!isHomePage && (
  //       <>
  //         {showLoader && Loader}
  //         <ThemeProvider theme={darkMode ? themeDark : theme}>
  //           <ConfirmAlert />
  //           <CssBaseline />
  //           {layout === "dashboard" && <Configurator />}
  //           {layout === "vr" && <Configurator />}
  //           {RouteConfigs}
  //         </ThemeProvider>
  //       </>
  //     )}
  //   </Suspense>
  // );
}
